<template>
    <BContainer>
        <div class="d-flex justify-left gap-3 align-items-center mt-4 mb-4">
            <h1>{{ t('News') }}</h1>
            <NewsSubscribtion />
        </div>
        <CategoriesList :categories="categories" v-if="categories" :current-category="category_id" class="mb-4 mt-4"/>
        <NewsList :news="news" v-if="news" :page="currentPage" />
        
        <ContentPagination 
            v-if="news && news.count > limit"
            :total="news?.count" 
            :limit="limit" 
            @update:offset="handleOffsetChange" 
        />
    </BContainer>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useAsyncData, useNuxtApp } from '#imports'
import { useI18n } from 'vue-i18n'
import NewsList from '~/components/site/news/NewsList.vue'
import ContentPagination from '~/components/site/ContentPagination.vue'
import CategoriesList from '~/components/site/news/CategoriesList.vue'
import NewsSubscribtion from '~/components/site/news/NewsSubscribtion.vue'
const route = useRoute()

const {locale, t} = useI18n()
const {$apiFetch} = useNuxtApp()

const limit = ref(20)
const offset = ref(0)
const category_id = computed(() => route.params.category_id)

// Calculate current page from URL
const currentPage = computed(() => {
    const pageParam = Number(route.query.page) || 1
    return pageParam
})

// Update offset when page changes
watch(currentPage, (newPage) => {
    offset.value = (newPage - 1) * limit.value
}, { immediate: true })

const handleOffsetChange = (newOffset: number) => {
    offset.value = newOffset
}

const { data: news } = useAsyncData(
    'news',
    () => $apiFetch(`/${locale.value}/api/site/news/`, {
        params: {
            limit: limit.value,
            offset: offset.value,
            ordering: '-date',
            category: category_id.value
        }
    }),
    {
        watch: [offset, locale]
    }
)

const { data: categories } = useAsyncData('categories', () =>
    $apiFetch(`/${locale.value}/api/site/news/categories/`)
)

definePageMeta({
    layout: 'site-layout-content',
    auth: 'guest'
})

useHead({
    title: t('News')
})

</script>

<i18n lang="json">
{
    "ru": {
        "News": "Новости"
    }
}
</i18n>

